import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f4d14a12&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f4d14a12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d14a12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4d14a12')) {
      api.createRecord('f4d14a12', component.options)
    } else {
      api.reload('f4d14a12', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f4d14a12&scoped=true", function () {
      api.rerender('f4d14a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customerServiceInformation/index.vue"
export default component.exports